import { connect } from 'react-redux';
import { sessionViewSelectors } from '../../../../../../../../redux/views/session-view/session/slice';
import { RootState } from '../../../../../../../../redux/store';
import { LeftPanelHeader } from '.';

export type LeftPanelHeaderProps = ReturnType<typeof mapStateToProps>;

export type LeftPanelHeaderContainerProps = { title: string };

const mapStateToProps = (
  state: RootState,
  ownProps: LeftPanelHeaderContainerProps,
) => ({
  leftPanelType: sessionViewSelectors.getLeftPanelType(state),
  title: ownProps.title || '',
});

export const LeftPanelHeaderContainer =
  connect(mapStateToProps)(LeftPanelHeader);
